import { render, staticRenderFns } from "./DialogueBox.vue?vue&type=template&id=df976da2&scoped=true&"
import script from "./DialogueBox.vue?vue&type=script&lang=js&"
export * from "./DialogueBox.vue?vue&type=script&lang=js&"
import style0 from "./DialogueBox.vue?vue&type=style&index=0&id=df976da2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df976da2",
  null
  
)

export default component.exports